import { render, staticRenderFns } from "./WarnStat.vue?vue&type=template&id=024f9833&scoped=true"
import script from "./WarnStat.vue?vue&type=script&lang=js"
export * from "./WarnStat.vue?vue&type=script&lang=js"
import style0 from "./WarnStat.vue?vue&type=style&index=0&id=024f9833&prod&lang=scss&scoped=true"
import style1 from "./WarnStat.vue?vue&type=style&index=1&id=024f9833&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f9833",
  null
  
)

export default component.exports